
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collection/propiedades",
      function () {
        return require("private-next-pages/collection/propiedades/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collection/propiedades"])
      });
    }
  